import { useLayoutEffect, useState } from "react";

/* The drawn width of an element, kept current as it resizes. Returns a callback
 * ref, so an element that mounts after the component is still measured, and
 * `fallback` until then or where the browser has no ResizeObserver. */
export default function useElementWidth(fallback) {
  const [element, setElement] = useState(null);
  const [width, setWidth] = useState(fallback);
  useLayoutEffect(() => {
    if (!element || typeof ResizeObserver === "undefined") return undefined;
    // A hidden element measures zero, which is not a width to lay out for.
    const update = (next) => { if (next > 0) setWidth((current) => (Math.abs(current - next) > 1 ? next : current)); };
    update(element.getBoundingClientRect().width);
    const observer = new ResizeObserver(([entry]) => update(entry.contentRect.width));
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);
  return [setElement, width];
}
